import React from "react";
import DeleteIcon from "../../assets/icons/fail.svg";
import WarningIcon from "../../assets/icons/warning-icon.svg";
export const ConfirmPopup = (props: any) => {
  const {
    showModal,
    children,
    footerContent,
    popupDiv,
    modalType = "delete",
    icon,
  } = props;
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      onScroll={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={`${
          showModal ? "block" : "hidden"
        } fixed inset-0 z-50 bg-[#0000004D] `}        
        style={{ backdropFilter: "blur(2px)" }}
      >
        <div
          className={`flex items-center justify-center p-4 min-h-screen w-full ${popupDiv} mx-auto`}
        >
          <div className="relative bg-white rounded-[8px] shadow w-full max-w-[400px] p-[24px]">
            <div className="relative">
              <div className="flex justify-center items-center rounded-t ">
                {icon && modalType === "delete" ? (
                  <img
                    src={DeleteIcon}
                    alt="profile"
                    width={58}
                    height={58}
                    className="w-[58px] h-[58px]"
                  />
                ) : icon && modalType === "warning" ? (
                  <img
                    src={WarningIcon}
                    alt="profile"
                    width={58}
                    height={58}
                    className="w-[58px] h-[58px]"
                  />
                ) : null}
              </div>

              <div className="mt-[10px]">{children}</div>
              {footerContent && (
                <div className="flex items-center justify-center p-4 md:p-5  rounded-b ">
                  {footerContent}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
